import { render, staticRenderFns } from "./AssignIssues.vue?vue&type=template&id=3f20f0cf&scoped=true"
import script from "./AssignIssues.vue?vue&type=script&lang=ts"
export * from "./AssignIssues.vue?vue&type=script&lang=ts"
import style0 from "./AssignIssues.vue?vue&type=style&index=0&id=3f20f0cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20f0cf",
  null
  
)

export default component.exports